import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ErrorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"error"}/>
}
